module.exports = __webpack_public_path__ + "img/coach.f5731253.png";